<template>
    <v-layout v-if="selectedBuyer" row wrap>
      <v-flex xs12>
        <buyer-info
          :firms="firms"      
          :buyers="buyers"
          :sellers="sellers" 
          :productRateCategories="productRateCategories"     
          :isBuyer="isBuyer"/>
      </v-flex>
      <v-flex xs12 sm12>
        <buyer-items :isBuyer="isBuyer"/>
      </v-flex>
      <v-flex xs12 sm12>
         <!-- <v-expansion-panel class="buyerInv" v-model="panel" expand>
          <v-expansion-panel-content>
            <template v-slot:header>
              <v-card-title class="primary white--text">
                  <h3 color="primary" ><b>TRANSACTIONS AND INVOICES</b></h3>
                </v-card-title>
            </template>
          
          </v-expansion-panel-content>
         </v-expansion-panel> -->
         <v-btn color="primary" @click="transactionView = !transactionView">
                       {{transactionView ? "Hide Transaction" : "Show Transaction"}}
          </v-btn>

          <buyer-invoice-expansion v-if="transactionView" :buyers="buyers"
                  :sellers="sellers" :isBuyer="isBuyer"/>

      </v-flex>
    </v-layout>
    <v-card v-else height = "100%" flat color="grey lighten-5">
        <v-card-text>
            <p class="text-md-center title ">
                {{emptyText}}
            </p>
        </v-card-text>
    </v-card>
</template>
<script>
import BuyerInfo from './BuyerInfo.vue'
import BuyerItems from './BuyerItems.vue'
import BuyerInvoiceExpansion from './BuyerInvoiceExpansion.vue'

import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']
export default {
  props: ['isBuyer'],
  data() {
    return {
      panel : [false],
      transactionView : false
    }
  },
  components: {
    BuyerInfo,
    BuyerItems,
    BuyerInvoiceExpansion
  },
  created () {
    // add 'equalTo' filter for tenant filteration
    this.$bindAsArray(
      'buyers',
      this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'sellers',
      this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray("productRateCategories", this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapBuyerGetters(['selectedBuyer']),
    ...mapGlobalGetters(['selectedBrand']),
    emptyText () {
      if (this.isBuyer) {
        return "Please select a Customer or Create a New Customer"
      } else {
        return "Please select a Supplier or Create a New Supplier"
      }
    },
  },
  methods: {
  },
  watch:{
    "$route.params.buyerId" : {
      handler(val){
        if(this.panel[0]!= false) {
          this.panel[0] = false
        }
        this.transactionView = false;
      },
      deep : true
    }
  }
}
</script>

<style>
.buyerInv .v-expansion-panel__header {
    background-color: #15155d;
}

.buyerInv .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/Buyer/index.vue